import { IResponse } from '@type/response';
import { qdfoodApi } from './constant';
import { IFormOrder, IOrder } from '@type/order';

export const ORDER_API = {
  urlCreateOrder: `/order/create/web_user`,
  urlListOrder: `/order/web_user`,
  urlDetailOrder: (id: string) => `/order/${id}`,
  urlSummaryOrder: `/order/summary/web_user`,
};

export default class orderApi {
  static createOrder(data: IFormOrder) {
    return qdfoodApi().post<IOrder>(ORDER_API.urlCreateOrder, data);
  }
  static getListOrder(params) {
    return qdfoodApi().get<IResponse<IOrder>>(ORDER_API.urlListOrder, {
      params,
    });
  }

  static getDetailOrder(id: string) {
    return qdfoodApi().get<IOrder>(ORDER_API.urlDetailOrder(id), {});
  }
  static getSummaryOrder() {
    return qdfoodApi().get(ORDER_API.urlSummaryOrder);
  }
}
